<template>
  <v-content class="login-view gradient-oblique">
    <v-container grid-list-lg class="max-width-500">
      <v-form id="login-form" v-model="form.valid" ref="form" lazy-validation @submit.prevent="validateLogin">
        <v-layout justify-center row wrap>

          <v-flex xs12 class="mt-4">
            <v-img src="./img/logo.svg" contain width="130px" height="130px" class="ma-auto"/>
          </v-flex>

          <v-flex xs12 class="text-xs-center mb-3 ">
            <div class="display-3">
              <span class="font-weight-bold success--text">Sprayer</span>
              <span class="font-weight-light white--text">Manager</span>
            </div>
          </v-flex>

          <!-- SELEZIONE VERSIONE DEL SITO
          <v-flex class="shrink">
            <span class="white--text pr-2 line-height-44">{{ $t('login.label.accedi_versione') }}:</span>
          </v-flex> -->

          <v-flex xs5 v-if="false">
            <combobox :items="versioni.items" :loading="versioni.loading"
                      item-value="ver" item-text="ver"
                      :value="currentVersion" @input="changeVersion"
                      dense dark color="white" box single-line class="mb-3 version-select"/>
          </v-flex>

          <v-flex xs12 class="mb-2">
            <text-field :label="$t('login.label.username')" v-model="form.username" required box dark color="white"/>
          </v-flex>

          <v-flex>
            <password-field :label="$t('login.label.password')" v-model="form.password" required box dark
                            color="white"/>
          </v-flex>

          <v-flex xs12 class="text-xs-right">
            <v-btn type="submit" form="login-form" :disabled="!form.valid" :loading="form.sending" color="white"
                   class="mx-0" block round>
              {{ $t('login.azioni.accedi') }}
            </v-btn>
          </v-flex>

          <!-- Alert in caso di blocco centro prova con nota di siegazione -->
          <v-flex xs12 class="mt-4">
            <v-alert v-if="form.suspendMessage" type="error" :value="form.suspendMessage" color="red" >
              {{ form.suspendMessage }}
            </v-alert>
          </v-flex>

        </v-layout>

      </v-form>
    </v-container>
  </v-content>
</template>

<script>
import { PasswordField } from '@/components/inputs'

export default {
    name: 'Login',
    components: { PasswordField },
    data: () => ({
        form: {
            sending: false,
            valid: true,
            username: '',
            password: '',
            suspendMessage: null
        },
        versioni: {
            items: [],
            loading: false
        }
    }),
    mounted () {
        if (this.isTokenExpired) {
            this.$snackbar.show(this.$t('errori.sessione_scaduta'), 'warning', { bottom: true })
            this.isTokenExpired = false
        }
        this.$api.versioni.get().then(response => {
            this.versioni.items = response.data
        }).catch(e => {
            this.$snackbar.showServerError(e, { bottom: true })
        })
    },
    computed: {
        isTokenExpired: {
            get () {
                return this.$store.state.session.isTokenExpired
            },
            set (val) {
                this.$store.commit('SET_IS_TOKEN_EXPIRED', val)
            }
        },
        currentVersion () {
            return window.location.pathname.replace(/^\/([^/]*).*$/, '$1')
        }
    },
    methods: {
        changeVersion (val) {
            window.location.href = location.protocol + '//' + window.location.host + '/' + val + '/'
        },
        validateLogin () {
            if (this.$refs.form.validate()) {
                this.login()
            }
        },
        login () {
            this.form.sending = true
            this.$store.dispatch('login', {
                username: this.form.username,
                password: this.form.password
            }).then(response => {
                this.$store.dispatch('invalidateCacheIndirizzi', response.data.comuniLastModified)
                this.form.sending = false
                const privilegi = response.data.privilegi
                console.log(privilegi)
                if (privilegi === 0){
                  //SUPERVISORE
                  console.log("Arrivo qui Supervisore")
                  this.$store.dispatch('logout')
                  const auth_token = response.data.key
                  document.cookie = `token=${auth_token}; path=/`  //il token servirà per l'autenticazione automatica
                  window.location.href = location.protocol + '//' + window.location.host + '/bew/portal/supervisore' 
                }else if (privilegi === 3){
                  //TECNICO non può accedere a questa pagina quindi viene mostrato errore
                  console.log("Arrivo qui Tecnico")
                  this.$snackbar.show(this.$t('login.errori.credenziali'), 'error', { bottom: true })
                  this.$router.push('/')
                }else{
                  //SEGRETARIA
                  console.log("Arrivo qui Segretaria")
                  localStorage.setItem("username", this.form.username)
                  this.$router.push('avvisi')
                }
                
            }).catch(e => {
                this.form.sending = false
                if (e.response && e.response.status === 401) {
                    if(e.response.data.bloccato){
                      this.form.suspendMessage = "Centro prova sospeso o bloccato: " + e.response.data.message
                      this.$snackbar.show(this.$t('login.errori.bloccato'), 'error', { bottom: true })
                    }else{
                      this.$snackbar.show(this.$t('login.errori.credenziali'), 'error', { bottom: true })
                    }
                } else {
                    this.$snackbar.showServerError(e, { bottom: true })
                }
            })
        }
    }
}
</script>
<style lang="scss">
  .login-view {
    .version-select .v-input__slot {
      min-height: 36px !important;
    }

    .error--text {
      $error: #ff6e30;
      color: $error !important;
    }

  }
</style>
